import { produce } from 'immer';
import { SET_USER, INIT_SET_USER_RESPONSE } from '../types/user';

const initialState = {
    id: null,
    fullName: null,
    mobileNumber: null,
    applicationType: null,
    isOtpRequired: true,
    clientCode: null,
    uniqueId: null,
    email: null,
    diyId: null,
    ekycId: null,
    // Branch quick-link id from ?zid=<GUID> (Zoho quick link).
    zohoQuickLinkId: null,
    // Set when the ?zid= / ?ekycid= resolve call rejects the id (invalid or
    // expired link). Lives in redux — not just in the form component — because
    // the landing page above the form keys the retail-offer sections off it.
    isQuickLinkInvalid: false,
    offerpaymentcompleted: "",
    paymentStatusEq: "",
    paymentStatusComm: "",
    strPSource: null,
    isDiy: "",
    pageName: "",
    pageIndex:"",
    verticalStepper:{
        user1ActiveIndex:1,
        user1CurrentIndex:0,
        user2ActiveIndex:3,
        user2CurrentIndex:0,
    },
    diymass: null,
    isEmailUpdated: null,
    valuepackPaymentCompleted: "",
    PaymentStatus: null,
    uniqueEmailId: '',
    referralCode: null,
    lsqId: null,
    opportunityId: null,
    branchCode: "",
    branchEmpCode: null,
    isAlliance: "",
    isBRBALogin: "",
    appLoginIdFromRedirect: "",
    branchEmpCodeFromRedirect: "",
    isWhatsappUser: true,
    whatsappUserPageName: "AADHAR",   // AADHAR   // CLIENTPHOTO   // PANSIGN    // INCOMEPROOFFO
    showReferralBanner: false,
    redirectionURL: "",
    oneMoneyStatus:"",
    IsReversePennyDrop:"",
    MFCust: "",
    intrestedIN: "",
    currectHolderStatus:"",
    initCalled:"",
    handoffResume: false,   // TKT-0045: 2nd-device resume prefills name+mobile on the registration page
    handoffRmResumeOtp: false, // EW-I7737: Zoho RM resume link at the mobile stage → land on the OTP box
    handoffOtpPreSent: false,  // EW-I7737: the OTP sent on the RM's click is still live (no resend needed)
}

const reducer = produce((state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_USER:
            return { ...state, ...payload };
        case INIT_SET_USER_RESPONSE:
            return { ...state, ...payload };
        default:
            return state
    }

})

export default reducer;